import React from "react";
import { useFreeShipping } from "../../../../hooks/useFreeShipping";

declare global {
  interface Window {
    Shopify?: {
      free_shipping_messages?: {
        icon?: string;
        unlocked?: string;
        in_progress?: string;
      };
    };
  }
}
interface CartFreeShippingProps {
  cartSubtotal: number;
  cartItems?: any[];
}

export const CartFreeShipping = ({ cartSubtotal }: CartFreeShippingProps) => {
  const { shippingData, isLoading } = useFreeShipping(cartSubtotal);

  if (isLoading) {
    return (
      <div className="p-4 mb-4 rounded-lg bg-gray-50">
        <div className="flex items-center justify-center">
          <div className="w-4 h-4 border-b-2 rounded-full animate-spin border-primary"></div>
          <span className="ml-2 text-sm text-primary">Loading shipping info...</span>
        </div>
      </div>
    );
  }

  if (!shippingData) {
    return null;
  }

  const {
    progressPercent,
    isUnlocked,
    formattedAmountLeft,
    formattedThreshold,
    countryCode,
  } = shippingData;

  // Generate the message directly in the component
  const progressMessage = isUnlocked 
    ? (window.Shopify?.free_shipping_messages?.unlocked)
    : (window.Shopify?.free_shipping_messages?.in_progress || "")
        .replace('{amount_left}', formattedAmountLeft)
        .replace('{{ amount_left }}', formattedAmountLeft);

  return (
    <div className="px-4 pt-4 lg:px-8 lg:pt-1 lg:pb-0">
      <div className="w-full h-[6px] mb-2 rounded-full bg-primary">
        <div
          className={`h-[6px] rounded-full transition-all duration-500 bg-tertiary`}
          style={{ width: `${progressPercent}%` }}
        />
      </div>
      <div className="flex items-center border-[#748b8533] border-b pb-3">
        {window.Shopify?.free_shipping_messages?.icon && (
          <img
            src={window.Shopify.free_shipping_messages.icon}
            alt="Free Shipping"
            className="w-6 h-6 mr-3"
          />
        )}
        <div className="flex-1">
          <p className={`text-xs/3 font-normal text-primary lg:text-sm`}>
            {progressMessage}
          </p>
        </div>
      </div>
    </div>
  );
};